package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.model.Visit
import fyi.moko.hotpl.domain.repository.PlaceRepository
import kotlinx.coroutines.flow.Flow

/** Streams the visit history of a place, newest first. */
class ObserveVisitsUseCase(
    private val repository: PlaceRepository,
) {
    operator fun invoke(placeId: String): Flow<List<Visit>> = repository.observeVisits(placeId)
}
